import { useEffect, useRef, useState } from 'react';

import type { PersonFormSection, PersonFormSectionControl } from '../../types/vida/cadastralMaintenance/personFormTypes';
import { isLastPersonFormSection } from '../../utils/personFormSectionUtils';

export function usePersonFormWizard(formKey: number | string) {
  const [activeSection, setActiveSection] = useState<PersonFormSection>('personData');
  const sectionControlRef = useRef<PersonFormSectionControl | null>(null);

  useEffect(() => {
    setActiveSection('personData');
  }, [formKey]);

  const isLastSection = isLastPersonFormSection(activeSection);

  const handleContinueOrSave = (onSave: () => void | Promise<void>) => {
    if (isLastSection) {
      void onSave();
      return;
    }

    sectionControlRef.current?.goToNextSection();
  };

  return {
    sectionControlRef,
    onActiveSectionChange: setActiveSection,
    isLastSection,
    handleContinueOrSave,
  };
}
